import { Component, Inject, OnInit } from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ChangeCollisionDialogComponentService } from 'src/app/lib/shared/components/dialog/change-collision-dialog/change-collision-dialog-component-service';
import { IssueAuditStatus, IssueAuditWrapper } from '../../../classes';
import { ISSUE_AUDIT_WRAPPER_PROVIDER } from '../../../interfaces';
import { IssueAuditWrapperComponentService } from '../issue-audit-wrapper/issue-audit-wrapper-service';

@Component({
  selector: 'app-issue-change-collision-wrapper',
  templateUrl: './issue-change-collision-wrapper.component.html',
  styleUrls: ['./issue-change-collision-wrapper.component.css'],
  providers: [
    { provide: ISSUE_AUDIT_WRAPPER_PROVIDER, useClass: IssueAuditWrapperComponentService }
  ]
})
export class IssueChangeCollisionWrapperComponent implements OnInit {

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(ISSUE_AUDIT_WRAPPER_PROVIDER) private _issueAuditWrapperProviderService: IssueAuditWrapperComponentService,
    private _changeCollisionDialogComponentService: ChangeCollisionDialogComponentService
  ) { }

  ngOnInit(): void {
    this._subscriptions.push(...[
      combineLatest([this._changeCollisionDialogComponentService.oldStatus$.pipe(filter(x => x? true: false)), this._changeCollisionDialogComponentService.newStatus$.pipe(filter(x => x? true: false))])
        .subscribe(([oldIssue, newIssue]) => {
          [oldIssue, newIssue].forEach(x => (x as IssueAuditStatus).guid = (x as IssueAuditStatus).concurrencystamp);
          (newIssue as IssueAuditStatus).anchestorId = (oldIssue as IssueAuditStatus).concurrencystamp;
          this._issueAuditWrapperProviderService.setIssueAuditWrapper({
            'issueStatus': [oldIssue, newIssue]
          } as IssueAuditWrapper)
        })
    ]);
  }

}
